import { render, staticRenderFns } from "./RequestsList.vue?vue&type=template&id=7ffb81be"
import script from "./RequestsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestsList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports